import { ErrorBoundary } from "../error-boundary";
import { RecentlyViewedProductsClient } from "./client";

/* ------------------------------------------------------------------ */
/*  Interface Contract                                                 */
/* ------------------------------------------------------------------ */

export interface RecentlyViewedProductsProps {
	/** If provided, records this SKU and excludes it from the display list. */
	currentSku?: string;
	/** Carousel heading. Defaults to "Recently Viewed". */
	title?: string;
	/** Max products shown in the carousel. Default: 12. */
	maxDisplay?: number;
	/** Suppress the design-system `<Container>` wrapper so the carousel
	 *  inherits its parent's content width. */
	embedded?: boolean;
	/** Allow slides to bleed past the carousel's right edge. Default `true`. */
	allowOverflow?: boolean;
}

/* ------------------------------------------------------------------ */
/*  Server Component                                                   */
/* ------------------------------------------------------------------ */

export function RecentlyViewedProducts(
	props: RecentlyViewedProductsProps
): JSX.Element {
	return (
		<ErrorBoundary componentId="recently_viewed_products">
			<RecentlyViewedProductsClient {...props} />
		</ErrorBoundary>
	);
}
